module.exports = __webpack_public_path__ + "static/gallery_09-cd3f88b6b2d5e75e09b17e04ef4addfe.jpg";